<template>
<div class="card">
  <div class="card-body help-card-body">
    <div class="text-center">
      <h4>R&egrave;sum&egrave; Heading</h4>
    </div>
    <hr>
    <h5>Full Name</h5>
    <p>This is at least your <b>first and last</b></p>

    <h5>Primary Phone Number </h5>
    <p>This is your evening phone number that you can be reached at.</p>

    <h5>Email Address</h5>
    <p>This is a major way that many employeers will be communicating with you. Make sure that you have a professional sounding e-mail account. A silly e-mail address might be a turn-off to possible employeers.</p>

    <h5>Secondary Phone Number</h5>
    <p>Even if you don't work at an office and have a number. Put your day telephone number here.</p>
  </div>
</div>
</template>

<script>
export default {
  name: 'heading',
  components: {

  },
  data() {
    return {

    }
  },
  methods: {

  }
}
</script>

<style>

</style>
